/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Aggregated
 */
export interface Aggregated {
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    cityAggresiveTakeoffPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    cityDangerousBreakingPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    cityDangerousTurnPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    countryDangerousBreakingPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    countryDangerousTurnPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    countryUnevenDrivePenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    highwayDangerousBreakingPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    highwayDangerousTurnPenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    highwayUnevenDrivePenalty: number;
    /**
     * 
     * @type {number}
     * @memberof Aggregated
     */
    highwayDangerousSpeedPenalty: number;
}

export function AggregatedFromJSON(json: any): Aggregated {
    return AggregatedFromJSONTyped(json, false);
}

export function AggregatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Aggregated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cityAggresiveTakeoffPenalty': json['city_aggresive_takeoff_penalty'],
        'cityDangerousBreakingPenalty': json['city_dangerous_breaking_penalty'],
        'cityDangerousTurnPenalty': json['city_dangerous_turn_penalty'],
        'countryDangerousBreakingPenalty': json['country_dangerous_breaking_penalty'],
        'countryDangerousTurnPenalty': json['country_dangerous_turn_penalty'],
        'countryUnevenDrivePenalty': json['country_uneven_drive_penalty'],
        'highwayDangerousBreakingPenalty': json['highway_dangerous_breaking_penalty'],
        'highwayDangerousTurnPenalty': json['highway_dangerous_turn_penalty'],
        'highwayUnevenDrivePenalty': json['highway_uneven_drive_penalty'],
        'highwayDangerousSpeedPenalty': json['highway_dangerous_speed_penalty'],
    };
}

export function AggregatedToJSON(value?: Aggregated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city_aggresive_takeoff_penalty': value.cityAggresiveTakeoffPenalty,
        'city_dangerous_breaking_penalty': value.cityDangerousBreakingPenalty,
        'city_dangerous_turn_penalty': value.cityDangerousTurnPenalty,
        'country_dangerous_breaking_penalty': value.countryDangerousBreakingPenalty,
        'country_dangerous_turn_penalty': value.countryDangerousTurnPenalty,
        'country_uneven_drive_penalty': value.countryUnevenDrivePenalty,
        'highway_dangerous_breaking_penalty': value.highwayDangerousBreakingPenalty,
        'highway_dangerous_turn_penalty': value.highwayDangerousTurnPenalty,
        'highway_uneven_drive_penalty': value.highwayUnevenDrivePenalty,
        'highway_dangerous_speed_penalty': value.highwayDangerousSpeedPenalty,
    };
}


